import './ContentCardGrid.scss';

interface ContentCardGridProps {
  title?: string;
  description?: string;
}

export function ContentCardGrid({ title, description }: ContentCardGridProps) {
  return (
    <section className="content-card-grid">
      {title && <h3 className="content-card-grid__title">{title}</h3>}
      {description && (
        <div
          className="content-card-grid__text"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
    </section>
  );
}
